import "../styles/WhatWeDo.css";

function WhatWeDo() {
  const services = [
    "Brand identity systems",
    "Market Positioning",
    "Acquisition Strategy",
    "Performance Campaigns",
    "Integrated marketing",
    "Content Ecosystems",
  ];

  return (
    <section className="what-we-do">

      <div className="section-label">
        <span className="line"></span>
        <p>What we do</p>
      </div>

      <div className="content">
        <h2>
          We combine <span>strategic clarity</span> with executional
          <span> precision</span> to move <span>brands</span> from insight to
          <span> market impact.</span>
        </h2>

        <div className="services">
          {services.map((service, index) => (
            <button key={index} className="service-btn">
              {service}
            </button>
          ))}
        </div>
      </div>

      

    </section>
  );
}

export default WhatWeDo;